export const blurActiveInputElement = () => {
  const inputElement = document.activeElement as HTMLInputElement | undefined;
  inputElement?.blur();
};
